import type * as Sentry from '@sentry/nextjs';

import { env } from './env';

type SentryConfig = Parameters<(typeof Sentry)['init']>[0];

export const defaultConfig: SentryConfig = env.NEXT_PUBLIC_SENTRY_ENABLED
  ? {
      enabled: env.NEXT_PUBLIC_SENTRY_ENABLED,
      dsn: env.NEXT_PUBLIC_SENTRY_DSN,
      environment: env.NEXT_PUBLIC_SST_STAGE,
      debug: false,
      tracesSampleRate: 0.05,
      release: `${process.env.NEXT_PUBLIC_SST_PROJECT}:${
        env.NEXT_PUBLIC_BUILD_COMMIT
      }`,
    }
  : { enabled: env.NEXT_PUBLIC_SENTRY_ENABLED };
